import React, {FC, useCallback, useEffect, useState} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {Select} from '../../../../../components/UI/Select'
import {ShowSnackBar} from '../../../../../util/functions'
import {getCheckingService2, searchGuestService} from '../../../services/checking.service'
import {getMasterModuleService} from '../../modules/services'

interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep1Parking: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {
    register,
    setValue,
    // watch,
    control,
    formState: {errors},
    // setError,
  } = useFormContext()
  const [, setSerialNumber] = useState('')
  const [docType, setDocType] = useState<any[]>([])
  const [, setSearching] = useState(false)
  const [modificated, setModificated] = useState(false)
  // const [maxLength, setMaxLength] = useState(8)
  const tipoDocumento = useWatch({name: 'tipoDocumentoId'})
  const numeroDocumento = useWatch({name: 'numeroDocumento'})
  const fromCamera = useWatch({name: 'fromCamera'})
  const operationType = useWatch({name: 'operationType'})
  const validateString = useWatch({name: 'validateString'})
  let numeroDocumentoChangeTimeout: any

  // const handleSubmit = () => {
  //     setSearching(true)
  //
  //     const tDocumento = docType.find((doc) => doc.value === tipoDocumento)
  //     functionMain(numeroDocumento, tDocumento)
  // }

  const handleNumeroDocumentoChange = useCallback(
    (value: string, docType: any[], modificated: boolean) => {
      setValue('numeroDocumento', value)
      // Realizar la acción deseada después de 2 segundos sin cambios
      clearTimeout(numeroDocumentoChangeTimeout)
      numeroDocumentoChangeTimeout = setTimeout(() => {
        if (value?.length > 0 && !modificated) {
          functionMain(value, docType)
        }
      }, 2000)
    },
    [setValue, tipoDocumento],
  )

  useEffect(() => {
    if (docType.length > 0) {
      handleNumeroDocumentoChange(numeroDocumento, docType, modificated)
    }
  }, [numeroDocumento, handleNumeroDocumentoChange, docType, modificated])

  useEffect(() => {
    if (!fromCamera) {
      setValue('numeroDocumento', '')
      setValue('isGuest', false)
      setValue('AceptaTyC', false)
      setValue('errorCheck', false)
      setValue('HuespedId', '')
      setValue('CamaId', '')
      setValue('ReservaId', '')
      setValue('bookingItem', {})
    }
  }, [fromCamera])

  const getDocTypeList = async () => {
    try {
      const response = await getMasterModuleService({
        pageNumber: 1,
        size: 100,
        tableName: 'TipoDocumento',
      })
      const data = response.data.data
      const filterData = data.filter(
        (item) => item.codigo !== '12' && item.codigo !== '11' && item.codigo !== '06',
      )
      const mappedMaster = filterData.map((master) => ({
        value: master.codigo,
        label: master.nombreCorto,
        length: master.campoadicionaltxt1,
      }))
      setDocType(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  const functionMain = async (numeroDocumento: string, documents: any[]) => {
    await handleGetGuest(numeroDocumento, documents)
    await goToStep(4)
  }

  const configDocString = (
    cadena: string,
    valorBase: string,
    direccion: 'IZQ' | 'DER',
    tipoDato: 'NUM' | 'ALF',
  ): string => {
    const newCadena = cadena.toLowerCase()
    const newValorBase = valorBase.toLowerCase()
    const index = newCadena.indexOf(newValorBase)

    if (index === -1) {
      return ''
    }
    const parteRelevante =
      direccion === 'IZQ' ? cadena.slice(0, index) : cadena.slice(index + valorBase.length)

    const regex = tipoDato === 'NUM' ? /\d+/g : /[a-zA-Z0-9]+/g

    const coincidencias = parteRelevante.match(regex)

    const resultados = coincidencias ? coincidencias.join('') : ''

    return resultados
  }

  const configDocStringExpresion = (expression: string, cadena: string) => {
    try {
      const regex = new RegExp(expression, 'g')
      const matches = cadena.match(regex)
      return matches ? matches.join('') : null
    } catch (error) {
      console.log('Error en la expresión regular:')
      return null
    }
  }

  const handleGetGuest = async (numeroDocumento: string, documents: any[]) => {
    setSearching(true)
    try {
      let modificateString = numeroDocumento
      if (validateString && tipoDocumento === '00') {
        const {ValorBase, TipoDato, Direccion, ActivaExpresion, Expresion} = validateString
        if (ActivaExpresion) {
          const expresion = configDocStringExpresion(Expresion, numeroDocumento)
          if (expresion) {
            modificateString = expresion
            setValue('numeroDocumento', modificateString)
            setModificated(true)
          } else {
            ShowSnackBar('Expresion Regular invalida', 'error')
            setSearching(false)
            return
          }
        } else {
          modificateString = configDocString(numeroDocumento, ValorBase, Direccion, TipoDato)
          setModificated(true)
          setValue('numeroDocumento', modificateString)
        }
      }
      if (modificateString.length === 0) {
        ShowSnackBar('Número de Documento invalido', 'error')
        setSearching(false)
        return
      }
      const {data: response} = await searchGuestService({
        TipoDocumentoId: tipoDocumento,
        NumeroDocumento: modificateString,
      })
      if (!response.error) {
        if (response.data.length > 0) {
          await setValue('isGuest', true)
          await setValue('AceptaTyC', response.data[0].AceptaTyC)
          await setValue('CompaniaId', response.data[0].CompaniaId)
          await setValue('ClienteId', response.data[0].ClienteId)
          await setValue('SiteId', response.data[0].SiteId)
          const tDocumento = documents.find((doc) => doc.value === tipoDocumento)
          await setValue('tipoDocumento_descripcion', tDocumento?.label)
          await getChekings(response.data[0].UsuarioId as any)
        }
      } else {
        ShowSnackBar('Hubo un error', 'error')
        setSearching(false)
        return
      }
    } catch (error) {
      setSearching(false)
    }
  }

  const getChekings = async (usuarioId: string) => {
    try {
      const {data: response} = await getCheckingService2({
        pageNumber: 1,
        size: 100,
        StatusCode: operationType === 'checkin' ? '2' : '3', //Checking
        UsuarioId: usuarioId,
      })
      if (response.data.length > 0) {
        await setValue('bookingItem', response.data[0])
        await setValue('CamaId', response.data[0].CamaId)
        await setValue('HuespedId', response.data[0].HuespedId)
        await setValue('ReservaId', response.data[0].ReservaId)
        await setValue('ReservaCamaId', response.data[0].ReservaCamaId)
      }
    } catch (error) {}
  }

  const handleCamera = () => {
    setValue('numeroDocumento', '')
    nextStep()
  }

  const handleToggleNFC = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked
    if (checked) {
      try {
        if ('NDEFReader' in window) {
          const ndef = new NDEFReader()
          await ndef.scan()
          ndef.onreadingerror = () => {
            console.error('Error al leer NFC.')
          }

          ndef.onreading = (event) => {
            console.log('NDEF message read.')
            onReading(event)
          }
          console.log('Scan started successfully.')
        } else {
          console.log('Not NDEFReader in Window')
          setTimeout(function () {
            e.target.checked = false
          }, 500)
        }
      } catch (error) {
        console.error('Error al leer NFC:', error)
      }
    }
  }

  const onReading = async ({message, serialNumber}: NDEFReadingEvent) => {
    setSerialNumber(serialNumber)
    setValue('numeroDocumento', serialNumber)

    console.log('message: ', message)
    console.log('serialNumber: ', serialNumber)

    for (const record of message.records) {
      console.log('Record: ', record)
      console.log('Record type: ', record.recordType)
      console.log('MIME type: ', record.mediaType)
      console.log('ID: ', record.id)
      console.log('Data: ', record.data)
      console.log('Encoding: ', record.encoding)
      console.log('Lang: ', record.lang)

      if (record.recordType === 'text') {
        const textDecoder = new TextDecoder(record.encoding)
        console.log('Text: ', textDecoder.decode(record.data))
        setSearching(true)
        await handleGetGuest(textDecoder.decode(record.data), docType)
      }
    }
  }

  useEffect(() => {
    getDocTypeList()
  }, [])

  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15'>
        <div className='fw-bold fs-6'>Porfavor ingrese sus datos</div>
      </div>
      {tipoDocumento === '00' && (
        <div className='row'>
          <div className='col-12'>
            <div className='mb-8'>
              <div className='form-check form-switch form-check-custom form-check-solid'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  value='nfc'
                  onChange={handleToggleNFC}
                  id='switchNFC'
                />
                <label className='form-check-label' htmlFor='switchNFC'>
                  NFC
                </label>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className='row'>
        <div className='col-lg-12'>
          <label className='required'>Tipo de Doc. Id.:</label>
          <Select
            control={control}
            name='tipoDocumentoId'
            data={docType}
            errors={errors}
            // onChangeValue={handleGetMaxLength}
          />
        </div>
        <div className='row'>
          <div className='col-10'>
            <label className='required'>Número de Doc. Id.:</label>
            <div className='sdx_form_input'>
              <input
                type={'text'}
                className='form-control sdx-centra-input-form'
                {...register('numeroDocumento')}
                autoFocus
              />
              {/* <InputNumberDoc
                name='numeroDocumento'
                textPlaceholder='Escribe el número'
                errors={errors}
                maxLength={maxLength}
                register={register}
                typeDoc={watch('tipoDocumentoId')}
              /> */}
            </div>
          </div>
          <div className='col-2'>
            <div className='input-group-append h-100 d-flex justify-content-center align-items-center mt-2'>
              <button className='btn btn-secondary' type='button' onClick={handleCamera}>
                <KTSVG
                  path='/media/icons/duotune/social/soc005.svg'
                  className='svg-icon-1'
                  color='black'
                />
              </button>
            </div>
          </div>
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
      <div className='d-flex flex-stack pt-15'>
        <div className='mr-2'>
          <button
            type='button'
            className='btn btn-lg btn-light-primary me-3'
            data-kt-stepper-action='previous'
            onClick={() => goToStep(1)}
          >
            Atras
          </button>
          {/*<button type='button' className='btn btn-lg btn-primary me-3' onClick={handleSubmit}*/}
          {/*        disabled={searching}*/}
          {/*>*/}
          {/*    {!searching && <span className='indicator-label'>Buscar Reserva</span>}*/}
          {/*    {searching && (*/}
          {/*        <span className='indicator-progress' style={{display: 'block'}}>*/}
          {/*                      Buscando...*/}
          {/*                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>*/}
          {/*                    </span>*/}
          {/*    )}*/}

          {/*</button>*/}
        </div>
      </div>
    </div>
  )
}

export {FormStep1Parking}
